<template>
  <div class="container o-product-slider mt-4">
    <h3 v-if="headline" class="mb-4 text-uppercase">
      {{ headline }}
    </h3>
    <div v-if="isLoading && typeof glideOptions.perView === 'number'" class="row overflow-hidden d-flex flex-nowrap">
      <div v-for="(n, index) in glideOptions.perView" :key="`skeleton-${index}`" class="o-product-slider__skeleton">
        <skeleton-loader layout="card" :aspect-ratio="2/3" />
      </div>
    </div>
    <vue-glide v-else-if="products" v-bind="glideOptions">
      <vue-glide-slide v-for="(product, index) in products" :key="index">
        <product-card
          class="mb-0"
          :product="product"
          show-add-to-cart-button
          :is-recommended="true"
          is-in-product-slider
        />
      </vue-glide-slide>
      <template
        slot="control"
      >
        <div data-glide-dir="<">
          <base-arrow
            class="o-product-slider__arrow arrow -left -inverted"
            aria-label="previous"
          />
        </div>
        <div data-glide-dir=">">
          <base-arrow
            class="o-product-slider__arrow arrow -inverted"
            aria-label="next"
          />
        </div>
      </template>
    </vue-glide>
  </div>
</template>

<script>
import SkeletonLoader from '@/components/atoms/SkeletonLoader.vue'
import { Glide, GlideSlide } from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';
import ProductCard from '@/components/organisms/ShopCommerce/ProductCard';
import BaseArrow from '@/components/atoms/BaseArrow';
import {
  trackProductImpressions,
} from '@/utils/enhancedEcomTracking';

export default {
  name: 'ProductSlider',
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
    ProductCard,
    SkeletonLoader,
    BaseArrow
  },
  props: {
    headline: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    listName: {
      type: String,
      default: 'Product slider'
    }
  },
  data () {
    return {
      glideOptions: {
        gap: 8,
        rewind: false,
        perView: 4.65,
        bound: true,
        bullet: true,
        breakpoints: {
          576: {
            perView: 1.3
          },
          768: {
            perView: 2.65,
          },
          950: {
            perView: 3.3
          },
          1024: {
            perView: 3.65,
          },
          1200: {
            perView: 4.3
          },
        }
      }
    };
  },
  computed: {
    currency () {
      return this.$store.getters['currency/getCurrentCurrency'];
    },
  },
  mounted () {
    trackProductImpressions (
      this.products,
      this.listName,
      this.currency
    );
  }
}
</script>
